var map = {
	"./bg/strings.json": 1924,
	"./cs/strings.json": 1925,
	"./da/strings.json": 1926,
	"./de/strings.json": 1927,
	"./el/strings.json": 1928,
	"./es-ES/strings.json": 1929,
	"./es-LA/strings.json": 1930,
	"./et/strings.json": 1931,
	"./fi/strings.json": 1932,
	"./fr-CA/strings.json": 1933,
	"./fr/strings.json": 1934,
	"./it/strings.json": 1935,
	"./lt/strings.json": 1936,
	"./lv/strings.json": 1937,
	"./nl/strings.json": 1938,
	"./no/strings.json": 1939,
	"./pl/strings.json": 1940,
	"./pseudo/strings.json": 1941,
	"./pt/strings.json": 1942,
	"./ro/strings.json": 1943,
	"./sk/strings.json": 1944,
	"./sl/strings.json": 1945,
	"./sv/strings.json": 1946,
	"./zh-CN/strings.json": 1947,
	"./zh-TW/strings.json": 1948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1923;